import React, { Component } from "react";

export default class LanguageComprehension extends Component {
  render() {
    var {
      comprehension_question_1,
      comprehension_question_2,
      comprehension_question_3,
      comprehension_question_4,
      comprehension_question_5,
      comprehension_question_6,
      comprehension_question_7,
      comprehension_question_8,
      language_comprehension_score,
      comprehension_question_checkbox_1,
      comprehension_question_checkbox_2,
      comprehension_question_checkbox_3,
      comprehension_question_checkbox_4,
      comprehension_question_checkbox_5,
      comprehension_question_checkbox_6,
      comprehension_question_checkbox_7,
      comprehension_question_checkbox_8,
    } = this.props.data;
    return (
      <div className="row p-3 border border-dark">
        <div className="col-lg-12">
          <div className="fs-19">
            <ul style={{ paddingLeft: 20 }}>
              <li style={{ listStyle: "square" }}>
                Administration:
                <ul style={{ paddingLeft: 40 }}>
                  <li style={{ listStyle: "circle" }}>
                    There are eight pictures displayed. Participants will name
                    the objects shown. No time limit is enforced for the task.
                    Incorrect answers are recorded and no prompt for alternative
                    word is provided. Self-corrections are allowed; only the
                    final answer is taken for scoring.
                  </li>
                </ul>
              </li>
              <li style={{ listStyle: "square" }}>
                Scoring
                <ul style={{ paddingLeft: 40 }}>
                  <li style={{ listStyle: "circle" }}>
                    Self-corrections are allowed; only the final answer is taken
                    for scoring.
                  </li>
                  <li style={{ listStyle: "circle" }}>
                    Note: If the participant incorrectly names an item in the
                    previous section, but identifies the correct item with the
                    wrong name in the comprehension section, score as correct.
                    For example, in the ECAS-A if the participant names the
                    Scorpion as ‘Lobster’ in the naming section, but answers
                    ‘Lobster’ when asked “Something with a sting” in the
                    comprehension section, score as correct. In this instance,
                    the person does not know the name of the item but does
                    comprehend what it is
                  </li>
                </ul>
              </li>
              <li style={{ listStyle: "square" }}>
                Say:
                <ul style={{ paddingLeft: 40 }}>
                  <li style={{ listStyle: "circle" }}>
                    Using the same pictures, can you try to answer the next 8
                    questions. There is no time limit.
                  </li>
                </ul>
              </li>
            </ul>
            <br />
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19">1. Something you can fly in </span>{" "}
                <input
                  className="position-relative"
                  style={{ width: 20, top: 3, left: 9 }}
                  type="checkbox"
                  checked={
                    comprehension_question_checkbox_1 == "1" ? true : false
                  }
                  name="comprehension_question_checkbox_1"
                />
              </div>
              <p className="correct-answer-p">
                <span className="font-weight-bold">Correct Answer:</span>{" "}
                Helicopter
              </p>
              <input
                value={comprehension_question_1}
                name="comprehension_question_1"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19">2. Something with webbed feet </span>{" "}
                <input
                  className="position-relative"
                  style={{ width: 20, top: 3, left: 9 }}
                  type="checkbox"
                  checked={
                    comprehension_question_checkbox_2 == "1" ? true : false
                  }
                  onChange={this.calculateComprehensionScore}
                  name="comprehension_question_checkbox_2"
                />
              </div>
              <p className="correct-answer-p">
                <span className="font-weight-bold">Correct Answer:</span> Swan
              </p>
              <input
                value={comprehension_question_2}
                name="comprehension_question_2"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19">3. An animal that climbs trees </span>{" "}
                <input
                  className="position-relative"
                  style={{ width: 20, top: 3, left: 9 }}
                  type="checkbox"
                  checked={
                    comprehension_question_checkbox_3 == "1" ? true : false
                  }
                  onChange={this.calculateComprehensionScore}
                  name="comprehension_question_checkbox_3"
                />
              </div>
              <p className="correct-answer-p">
                <span className="font-weight-bold">Correct Answer:</span>{" "}
                Squirrel
              </p>
              <input
                value={comprehension_question_3}
                name="comprehension_question_3"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19">4. Something used for chopping </span>{" "}
                <input
                  className="position-relative"
                  style={{ width: 20, top: 3, left: 9 }}
                  type="checkbox"
                  onChange={this.calculateComprehensionScore}
                  name="comprehension_question_checkbox_4"
                  checked={
                    comprehension_question_checkbox_4 == "1" ? true : false
                  }
                />
              </div>
              <p className="correct-answer-p">
                <span className="font-weight-bold">Correct Answer:</span> Axe
              </p>
              <input
                value={comprehension_question_4}
                name="comprehension_question_4"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19">5. A means of transport </span>{" "}
                <input
                  className="position-relative"
                  style={{
                    width: 20,
                    top: 3,
                    left: 9,
                  }}
                  type="checkbox"
                  checked={
                    comprehension_question_checkbox_5 == "1" ? true : false
                  }
                  onChange={this.calculateComprehensionScore}
                  name="comprehension_question_checkbox_5"
                />
              </div>
              <p className="correct-answer-p">
                <span className="font-weight-bold">Correct Answer:</span>{" "}
                Helicopter
              </p>
              <input
                value={comprehension_question_5}
                name="comprehension_question_5"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19">6. Something with a sharp edge </span>{" "}
                <input
                  className="position-relative"
                  style={{
                    width: 20,
                    top: 3,
                    left: 9,
                  }}
                  type="checkbox"
                  checked={
                    comprehension_question_checkbox_6 == "1" ? true : false
                  }
                  onChange={this.calculateComprehensionScore}
                  name="comprehension_question_checkbox_6"
                />
              </div>
              <p className="correct-answer-p">
                <span className="font-weight-bold">Correct Answer:</span> Axe
              </p>
              <input
                value={comprehension_question_6}
                name="comprehension_question_6"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19">7. Something with a sting </span>{" "}
                <input
                  className="position-relative"
                  style={{
                    width: 20,
                    top: 3,
                    left: 9,
                  }}
                  type="checkbox"
                  checked={
                    comprehension_question_checkbox_7 == "1" ? true : false
                  }
                  onChange={this.calculateComprehensionScore}
                  name="comprehension_question_checkbox_7"
                />
              </div>
              <p className="correct-answer-p">
                <span className="font-weight-bold">Correct Answer:</span>{" "}
                Scorpion
              </p>
              <input
                value={comprehension_question_7}
                name="comprehension_question_7"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex">
                <span className="fs-19">
                  8. Something with a diet of nuts and seeds{" "}
                </span>{" "}
                <input
                  className="position-relative"
                  style={{
                    width: 20,
                    top: 3,
                    left: 9,
                  }}
                  type="checkbox"
                  checked={
                    comprehension_question_checkbox_8 == "1" ? true : false
                  }
                  onChange={this.calculateComprehensionScore}
                  name="comprehension_question_checkbox_8"
                />
              </div>
              <p className="correct-answer-p">
                <span className="font-weight-bold">Correct Answer:</span>{" "}
                Squirrel
              </p>
              <input
                value={comprehension_question_8}
                name="comprehension_question_8"
                type="text"
                className="ecas-input-field"
              />
            </div>
          </div>
          <hr style={{ marginBottom: 29 }} />

          <div className="pl-0 col-lg-6 text-left">
            <span className="fs-19">Score (0-8) </span>
            <input
              type="number"
              name="language_comprehension_score"
              readOnly=""
              className="ecas-input-field"
              placeholder="Score"
              value={language_comprehension_score}
            />
          </div>
        </div>
      </div>
    );
  }
}
